export default "__VITE_PUBLIC_ASSET__c18592c9__"